import React, { ComponentClass, PureComponent, ReactNode } from "react";
import { Mutation, MutationResult } from "react-apollo";

import {
  ICart,
  ICartProductDetail,
  ICartProductRemoveInput,
} from "../../../types/cart";
import {
  computeCartSubTotal,
  computeCartTotal,
} from "../../services/optimistic-response.service";

import CartProductRemove from "./graphql/CartProductRemove";

export interface IProductRemove {
  cartProductRemove: (params: {
    variables: { input: ICartProductRemoveInput };
  }) => Promise<MutationResult<void>>;
}

export default <P extends object>(
  Component: React.ComponentType<P>
): ComponentClass<P> =>
  class CartProductRemoveClass extends PureComponent<
    P & { cart?: ICart | null }
  > {
    public render(): ReactNode {
      return (
        <Mutation mutation={CartProductRemove}>
          {(
            cartProductRemove: (params: {
              optimisticResponse: object;
              variables: {
                input: ICartProductRemoveInput;
              };
            }) => void
          ): JSX.Element => {
            return (
              <Component
                {...this.props}
                cartProductRemove={(params: {
                  variables: { input: ICartProductRemoveInput };
                }): void => {
                  const { cart } = this.props;
                  const { productId } = params.variables.input;

                  let optimisticResponse = {};

                  if (cart != null) {
                    const newCart = {
                      ...cart,
                      items: cart.items
                        .map((el: ICartProductDetail) => ({ ...el }))
                        .filter(
                          (item: ICartProductDetail) =>
                            item.product.id !== productId
                        ),
                    };

                    const newSubTotal = computeCartSubTotal(newCart.items);
                    const newTotal = computeCartTotal(
                      newSubTotal,
                      newCart.coupon,
                      newCart.giftCards
                    );

                    optimisticResponse = {
                      __typename: "Mutation",
                      cartProductRemove: {
                        __typename: "Cart",
                        ...newCart,
                        subTotal: newSubTotal,
                        total: newTotal,
                      },
                    };
                  }

                  return cartProductRemove({
                    ...params,
                    optimisticResponse,
                  });
                }}
              />
            );
          }}
        </Mutation>
      );
    }
  };
